import { useIntl } from 'react-intl';
import { forwardRef } from '@chakra-ui/react';

import { Table } from '../../Table';
import { type RowProps } from '../../Table/parts';
import { useFees } from '../context';

export type WithdrawalEuroProps = RowProps;

export const WithdrawalEuro = forwardRef<WithdrawalEuroProps, 'div'>(
  (props, ref) => {
    const intl = useIntl();
    const { fees, quotas, toFixed, toVariable } = useFees();

    const locales = {
      label: intl.formatMessage({
        id: 'subscription.fees_modal.withdrawal_euro.label',
      }),
      value: intl.formatMessage(
        {
          id: 'subscription.fees_modal.withdrawal_euro.value',
        },
        {
          fixed: toFixed(fees.additionalWithdrawalEuro),
          limit: quotas.withdrawalMonthQuota.limit,
          variable: toVariable(fees.additionalWithdrawalEuro),
        },
      ),
    };

    return (
      <Table.Row {...props} ref={ref}>
        <Table.CellText>{locales.label}</Table.CellText>
        <Table.CellAmount>{locales.value}</Table.CellAmount>
      </Table.Row>
    );
  },
);
